import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import GeofencingService from "src/service/geofencing";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Update User ",
  },
];

const validationSchema = yup.object({
  username: yup
    .string("Enter User Name")
    .matches(
      /^[a-zA-Z ]+$/,
      "User Name should only contain small Alphabet without space"
    )
    .min(2, "User Name should be of minimum 2 characters in length")
    .max(30, "User Name should be of maximum 30 characters in length")
    .required("User Name is required"),

  contact: yup
    .string("Enter Contact No")
    .matches(/^[0-9]+$/, "Contact No should only contain digits")
    .min(10, "Contact number should be at least 10 digits long")
    .max(10, "Contact number should not exceed 10 digits")
    .required("Contact no is Required"),
});

const UpdateUserlist = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const param = useParams();

  const [districtList, setDistrictList] = useState([]);

  const fetchDistrictList = async () => {
    try {
      const res = await GeofencingService.fetch_district_list({});
      setDistrictList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDistrictList();
    fetch_userData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    district_id: "",
    vehicle_type: "",
    username: "",
    contact: "",
    d_by: sessionData.data.id,
    device_setup: false,
    drive_setup: false,
    root_map_setup: false,
    geo_fence_setup: false,
    alert_time_setup: false,
    set_alert_notification: false,
  });

  const fetch_userData = async () => {
    try {
      const res = await UserService.get_userList({
        id: param.id,
      });

      setInitialValues({
        id: param.id,
        district_id: res.data[0].district_id,
        vehicle_type: res.data[0].vehicle_type,
        username: res.data[0].username,
        contact: res.data[0].contact,
        d_by: sessionData.data.id,
        device_setup: res.data[0].device_setup === 1,
        drive_setup: res.data[0].drive_setup === 1,
        root_map_setup: res.data[0].root_map_setup === 1,
        geo_fence_setup: res.data[0].geo_fence_setup === 1,
        alert_time_setup: res.data[0].alert_time_setup === 1,
        set_alert_notification: res.data[0].set_alert_notification === 1,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const updatedValues = {
        ...values,
        device_setup: values.device_setup ? 1 : 0,
        drive_setup: values.drive_setup ? 1 : 0,
        root_map_setup: values.root_map_setup ? 1 : 0,
        geo_fence_setup: values.geo_fence_setup ? 1 : 0,
        alert_time_setup: values.alert_time_setup ? 1 : 0,
        set_alert_notification: values.set_alert_notification ? 1 : 0,
      };

      try {
        const res = await UserService.updateUserData(updatedValues);
        swal("success", res.message, "success");
        setTimeout(() => {
          navigate("/userlist");
        }, 1000);
      } catch (error) {
        swal("error", error.message, "error");
      }
    },
  });

  const vehicleTypeOptions = [
    { value: "e", label: "ERV" },
    { value: "f", label: "Fire Brigade" },
    { value: "e,f", label: "Both ERV & Fire Brigade" },
  ];

  return (
    <>
      <Breadcrumb title="Update User List" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update User List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/userlist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="username">
                User Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="username"
                name="username"
                type="text"
                value={formik.values.username}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase().replace(/\s/g, "");
                  formik.setFieldValue("username", value);
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.username && Boolean(formik.errors.username)
                }
                helperText={formik.touched.username && formik.errors.username}
                variant="outlined"
                placeholder="Enter username"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="contact">
                Contact No
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="contact"
                name="contact"
                type="text"
                value={formik.values.contact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.contact && Boolean(formik.errors.contact)}
                helperText={formik.touched.contact && formik.errors.contact}
                variant="outlined"
                placeholder="Enter Contact no"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="district_id">
                District <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="district_id"
                name="district_id"
                options={districtList}
                getOptionLabel={(option) => `${option.district_name}`}
                value={
                  districtList.find(
                    (district) => district.id === formik.values.district_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue("district_id", newValue?.id || "");
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      formik.touched.district_id &&
                      Boolean(formik.errors.district_id)
                    }
                    helperText={
                      formik.touched.district_id && formik.errors.district_id
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a District"
                  />
                )}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_type">
                Vehicle Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_type"
                name="vehicle_type"
                options={vehicleTypeOptions}
                getOptionLabel={(option) => `${option.label}`}
                value={
                  vehicleTypeOptions.find(
                    (item) => item.value === formik.values.vehicle_type
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue("vehicle_type", newValue?.value || "");
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      formik.touched.vehicle_type &&
                      Boolean(formik.errors.vehicle_type)
                    }
                    helperText={
                      formik.touched.vehicle_type && formik.errors.vehicle_type
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a vehicle type"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: "20px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={2} mb={2}>
              <h6>Setup Settings</h6>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="device_setup"
                    name="device_setup"
                    checked={formik.values.device_setup}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Device Setup"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="drive_setup"
                    name="drive_setup"
                    checked={formik.values.drive_setup}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Driver Setup"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="root_map_setup"
                    name="root_map_setup"
                    checked={formik.values.root_map_setup}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Route Map Setup"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="geo_fence_setup"
                    name="geo_fence_setup"
                    checked={formik.values.geo_fence_setup}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Geo Fencing Setup"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="alert_time_setup"
                    name="alert_time_setup"
                    checked={formik.values.alert_time_setup}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Alert Time Setup"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="set_alert_notification"
                    name="set_alert_notification"
                    checked={formik.values.set_alert_notification}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="Set Alert Notification"
              />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default UpdateUserlist;
